module.exports = __webpack_public_path__ + "static/media/portfolio4.59104b32.jpg";